module.exports = __webpack_public_path__ + "static/media/How2wework.a5667422.webp";